require("packs/rawgit")
$(document).ready(function() {
  //For editable select box load select box onload
  $("#user_organization_name").editableSelect('show');
  $("#user_organization_name").attr("placeholder", "Enter New Organization Name Or Select Organization Name");
  email_domain = $('#user_email').val().split('@')[1];
  email_domain = email_domain ? email_domain.split('.')[0] : 1
  if (email_domain != 1){
    var org_url = window.location.origin+'/get_org/'+email_domain
    $.ajax({url: org_url, success: function(result){
      result = result.data
      option = ""
      $("#user_organization_name").editableSelect({ effects: 'slide' });
      $.each(result, function(index, value) {
        $("#user_organization_name").editableSelect('add', value[1]);
      });
    }});
  }

  $('#user_organization_name').focusout(function(event){
    $('#sign_up').attr("disabled", false);
    $('#error_organization').remove();
  });

  // For dynamic organization name based on email
  $('#user_email').change(function(event){
    var domain = $('#user_email').val().split('@')[1]
    domain = domain ? domain.split('.')[0] : 1
    $("#user_organization_name").val('');
    $("#user_organization_name").editableSelect('clear');
    if (domain != 1){
      var org_url = window.location.origin+'/get_org/'+domain
      $.ajax({url: org_url, success: function(result){
        result = result.data
        option = ""
        $("#user_organization_name").editableSelect({ effects: 'slide' });
        $.each(result, function(index, value) {
          $("#user_organization_name").editableSelect('add', value[1]);
        });
      }});
    }
  });

  //For validate select box on form submit
  $('#new_user').submit(function( event ) {
    select_value = $('#user_organization_name').val().length
    var regex = new RegExp("^[a-zA-Z ]*$");
    var first_name = $('#user_first_name').val()
    var last_name = $('#user_last_name').val()
    $('#error_info').empty();
    if (select_value == 0){
      $('input[name="authenticity_token"]').after("<div id='error_info'><ul style='text-align: left;'><li>Organization Name Shouldn't be blank</li></ul></div>");
      event.preventDefault();
    }else if (!regex.test(first_name)){
      $('input[name="authenticity_token"]').after("<div id='error_info'><ul style='text-align: left;'><li>First name shouldn't contain special characters or numbers </li></ul></div>");
      event.preventDefault();
    }else if (!regex.test(last_name)){
      $('input[name="authenticity_token"]').after("<div id='error_info'><ul style='text-align: left;'><li>Last name shouldn't contain special characters or numbers </li></ul></div>");
      event.preventDefault();
    }
  });
 

});